import chart from "../assets/images/pages/infographics/infogrphics-counter/chart-bar.svg";
import graph from "../assets/images/pages/infographics/infogrphics-counter/graph.svg";
import pie_chart from "../assets/images/pages/infographics/infogrphics-counter/pie-chart.svg";

const graphics_counter_icons = [
  {
    id: 0,
    icon: pie_chart,
  },
  {
    id: 1,
    icon: chart,
  },
  {
    id: 2,
    icon: graph,
  },
  {
    id: 3,
    icon: graph,
  },
];

export default graphics_counter_icons;
